import * as React from 'react';

function SvgStatsCdn(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 65 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable={false}
      {...props}
    >
      <path
        opacity={0.21}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.175 30v7c0 12.703 10.297 23 23 23h18c12.702 0 23-10.297 23-23V23c0-12.703-10.298-23-23-23h-18c-12.703 0-23 10.297-23 23v7z"
        fill="#4255FF"
      />
      <path
        d="M30.938 20c3.78 0 7.093 2.688 7.812 6.25 3.438 0 6.25 2.813 6.25 6.25 0 3.438-2.813 6.25-6.25 6.25H24.687A4.681 4.681 0 0120 34.062c0-2.03 1.313-4.03 3.125-4.687v-1.563c0-4.312 3.5-7.812 7.813-7.812z"
        fill="#4255FF"
      />
    </svg>
  );
}

export default SvgStatsCdn;
